<template>
    <fees-write-off-update
        :uuid="fee.uuid"
        @success="show_edit_modal = false; show_updated_modal = true"
    >
        <div
            slot-scope="{
                is_loading: is_saving,
                error,
                update,
                forget
            }"
        >
            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_updated_modal"
                :is-open="show_updated_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Fee Updated!</template>

                <p>The fee has been successfully updated. We have notified your tenant(s) of the write-off.</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="btn text-center"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-red
                v-else-if="show_edit_modal"
                :is-open="show_edit_modal"
                @close="closeAll"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="update"
                >
                    <div class="border-b px-4 pt-6 sm:px-6">
                        <h6 class="text-center font-semibold text-lg font-normal mb-3">
                            Write-off Balance
                        </h6>

                        <base-alert
                            v-if="!fee.can_write_off"
                            level="warning"
                            class="mb-6"
                        >
                            <template slot="heading">Hang fire!</template>

                            <template slot="content">
                                <p class="mb-3">You cannot write-off a fee that has pending payments.</p>

                                <p>Acknowledge any pending offline payments, and wait for any online payments to process before trying again.</p>
                            </template>
                        </base-alert>

                        <div
                            v-else
                            class="text-grey-darker mb-6"
                        >
                            <p class="mb-3">
                                If you know you're not going to receive this fee, you can write it off the oustanding balance.
                            </p>

                            <p><strong>You cannot undo this action.</strong></p>
                        </div>
                    </div>

                    <footer class="flex flex-col md:flex-row-reverse bg-grey-bg rounded-b py-3 px-6">
                        <base-button
                            v-if="fee.can_write_off"
                            :is-loading="is_saving"
                            type="submit"
                            class="btn btn-red w-full md:w-auto md:ml-3"
                        >
                            Write-off
                        </base-button>

                        <button
                            type="button"
                            class="btn text-center"
                            @click.prevent="close"
                        >
                            {{ fee.can_write_off ? 'Cancel' : 'Close' }}
                        </button>
                    </footer>
                </base-form>
            </modal-red>
        </div>
    </fees-write-off-update>
</template>

<script>
    import FeesWriteOffUpdate from '../../../../../../components/fees-write-off-update'

    export default {
        components: {
            FeesWriteOffUpdate
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            fee: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_edit_modal: this.toggled,
                show_updated_modal: false
            }
        },
        watch: {
            toggled () {
                this.show_edit_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_updated_modal = false
                this.show_edit_modal = false

                this.$emit('toggle', false)
            },
            onSuccess () {
                this.show_edit_modal = false
                this.show_updated_modal = true
            }
        }
    }
</script>
